import { Controller } from "stimulus"
import * as Turbo from "@hotwired/turbo"
import { clicksSinceRefresh } from "./click_tracker_controller"

export default class extends Controller {
  static values = { url: String }

  async refresh() {
    if (document.visibilityState !== "visible" || this.refreshing || clicksSinceRefresh.size === 0) return

    this.refreshing = true
    const clicks = [...clicksSinceRefresh]
    try {
      await Promise.all(clicks)
      const response = await fetch(this.refreshUrl(), {
        headers: { Accept: "text/vnd.turbo-stream.html" },
        cache: "no-store"
      })
      if (!response.ok || response.redirected || !response.headers.get("Content-Type")?.includes("text/vnd.turbo-stream.html")) return

      clicks.forEach((click) => clicksSinceRefresh.delete(click))
      const stream = await response.text()
      if (this.element.isConnected) Turbo.renderStreamMessage(stream)
    } catch (error) {
      globalThis.Rollbar?.error(error, { detail: "Catalog refresh failed" })
    } finally {
      this.refreshing = false
    }
  }

  restore(event) {
    if (event.persisted) this.refresh()
  }

  // The status select advances the URL from inside a Turbo frame, so the address bar
  // holds the current status, not the value rendered into this controller.
  refreshUrl() {
    const url = new URL(this.urlValue, window.location.origin)
    const status = new URL(window.location.href).searchParams.get("status")
    if (status) url.searchParams.set("status", status)
    return url
  }
}
